<script>
export default {
    mounted() {
        this.$router.replace('/dashboard')
    },
}
</script>
